import e from "@dialpad/dialtone-tokens/layered/themes/tokens-alpine-colors.css?inline";
//#region themes/alpine.js
var t = {
	brand: {
		css: e,
		name: "alpine"
	},
	material: { name: "steel" }
};
//#endregion
export { t as default };
